import {css} from "@emotion/css"

export const InputStyles = css`
  width: 100%;
`

export const SubmitBtn = css`
  width: 100%;
  height: 46px;
`
